import React from 'react';

export const CloseIcon = ({ color = '#667085', size = 44 }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 44 44'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M28 16L16 28M16 16L28 28'
            stroke={color}
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
